module.exports = __webpack_public_path__ + "img/icon_t3.c6417398.png";